//   document.addEventListener('DOMContentLoaded', function () {
//    const faq_item = document.querySelectorAll(".faq-list .faq-item");

//   if (faq_item.length > 0){
//     const firs_item = faq_item[0];
//     const first_faqQus = firs_item.querySelector('.faq-question');
//     const first_faqAns = firs_item.querySelector('.faq-answer');

//     if (first_faqQus && first_faqAns) {
//       firs_item.classList.add('open');
//       first_faqQus.classList.add('active');
//       first_faqAns.style.height = first_faqAns.scrollHeight + 'px';
//     }
//   }

//   faq_item.forEach((item) =>{
//     const faq_qus = item.querySelector(".faq-question");
//     const faq_ans = item.querySelector(".faq-answer");

//     if (faq_qus && faq_ans){
//       faq_qus.addEventListener("click", function(){
//         const isOpen = item.classList.contains("open");

//         faq_item.forEach( i => {
//           const qus = i.querySelector(".faq-question");
//           const ans = i.querySelector(".faq-answer");

//           if (qus && ans){
//             i.classList.remove("open");
//             qus.classList.remove("active");
//             ans.style.height = '0';
//           }
//         });

//         if(!isOpen){
//           item.classList.add("open");
//           faq_qus.classList.add("active");
//           faq_ans.style.height = faq_ans.scrollHeight + "px";
//         }
//       });
//     }
//   });

// });
document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-list .faq-item");
  const loadMoreBtn = document.querySelector(".load-more-faq");
  const batchSize = 4;
  let currentIndex = 0;

  function showFaqs() {
    for (
      let i = currentIndex;
      i < currentIndex + batchSize && i < faqItems.length;
      i++
    ) {
      faqItems[i].style.display = "block";
    }
    currentIndex += batchSize;


    if (currentIndex >= faqItems.length) {
      loadMoreBtn.style.display = "none";
    }


    if (currentIndex === batchSize) {
      const firstVisibleItem = faqItems[0];
      const firstQus = firstVisibleItem.querySelector(".faq-question");
      const firstAns = firstVisibleItem.querySelector(".faq-answer");

      firstVisibleItem.classList.add("open");
      firstQus.classList.add("active");
      firstAns.style.height = firstAns.scrollHeight + "px";
    }
  }

  showFaqs(); 

  loadMoreBtn.addEventListener("click", showFaqs);


  faqItems.forEach((item) => {
    const faqQus = item.querySelector(".faq-question");
    const faqAns = item.querySelector(".faq-answer");

    if (faqQus && faqAns) {
      faqQus.addEventListener("click", function () {
        const isOpen = item.classList.contains("open");

        faqItems.forEach((i) => {
          const qus = i.querySelector(".faq-question");
          const ans = i.querySelector(".faq-answer");

          if (qus && ans) {
            i.classList.remove("open");
            qus.classList.remove("active");
            ans.style.height = "0";
          }
        });

        if (!isOpen) {
          item.classList.add("open");
          faqQus.classList.add("active");
          faqAns.style.height = faqAns.scrollHeight + "px";
        }
      });
    }
  });
});
